var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("personalizedDesignsHelperService", function () {
    function variantFileTypesMatchLetteringCondition(fta) {
        if (!fta || typeof fta !== "string") {
            return false;
        }
        var l = fta.toLowerCase();
        return (
            l.indexOf("emb") !== -1 && l.indexOf("embrilliance") === -1
        );
    }

    function variantFileTypesMatchResizeCondition(fta) {
        if (!fta) {
            return false;
        }
        var types = Array.isArray(fta) ? fta : String(fta).split(",");
        return types.some(function (f) {
            var t = (f || "").toString().trim().toLowerCase();
            return t === "emb" || t === "pes";
        });
    }

    function sourceHasResizeEligibleVariant(src) {
        var variants = src && src.variants;
        if (!variants || !variants.length) {
            return false;
        }
        for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var fta =
                v.fileTypesAvailable ||
                (Array.isArray(v.fTA) ? v.fTA.join(",") : v.fTA) ||
                "";
            if (variantFileTypesMatchResizeCondition(fta)) {
                return true;
            }
        }
        return false;
    }

    function stockDesignSourceHasLetteringEligibleVariant(src) {
        var variants = src && src.variants;
        if (!variants || !variants.length) {
            return false;
        }
        for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            var fta =
                v.fileTypesAvailable ||
                (Array.isArray(v.fTA) ? v.fTA.join(",") : v.fTA) ||
                "";
            if (variantFileTypesMatchLetteringCondition(String(fta))) {
                return true;
            }
        }
        return false;
    }

    function getLineItemProductId(item) {
        return (item.productId || item.sku || "")
            .split(/_var_/gi)[0]
            .toLowerCase();
    }

    /** Order history line items expose downloadableFileTypes from the orders API. */
    function lineItemHasLetteringEligibleFileTypes(item) {
        if (!item) {
            return false;
        }
        var fta = item.downloadableFileTypes;
        if (Array.isArray(fta)) {
            fta = fta.join(",");
        }
        return variantFileTypesMatchLetteringCondition(String(fta || ""));
    }

    function normalizeFileTypesToCsv(fta) {
        if (!fta) {
            return "";
        }
        if (Array.isArray(fta)) {
            return fta.join(",");
        }
        return String(fta);
    }

    function coalesceVariantInches(value, mmValue) {
        var n = parseFloat(value, 10);
        if (!isNaN(n) && n > 0) {
            return n;
        }
        var mm = parseFloat(mmValue, 10);
        if (!isNaN(mm) && mm > 0) {
            return mm / 25.4;
        }
        return 0;
    }

    /** e.g. AK01-AK1132_var_3 → "3" */
    function parseVariantIdFromPurchasedSku(purchasedSku) {
        if (!purchasedSku) {
            return null;
        }
        var parts = String(purchasedSku).split(/_var_/i);
        if (parts.length < 2 || !parts[1]) {
            return null;
        }
        return String(parts[1]).toLowerCase();
    }

    function getVariantIdKey(v) {
        if (!v || v.variantId === undefined || v.variantId === null) {
            return "";
        }
        return String(v.variantId).toLowerCase();
    }

    /** Find variant by variantId from SKU (_var_N), not by array index or substring. */
    function findVariantByPurchasedSku(variants, purchasedSku) {
        if (!variants || !variants.length || !purchasedSku) {
            return null;
        }
        var purchasedSkuLower = String(purchasedSku).toLowerCase();
        var purchasedVariantId = parseVariantIdFromPurchasedSku(purchasedSku);
        var i;
        var v;

        if (purchasedVariantId) {
            for (i = 0; i < variants.length; i++) {
                v = variants[i] || {};
                if (getVariantIdKey(v) === purchasedVariantId) {
                    return v;
                }
            }
        }

        for (i = 0; i < variants.length; i++) {
            v = variants[i] || {};
            if ((v.itemId || "").toLowerCase() === purchasedSkuLower) {
                return v;
            }
        }

        return null;
    }

    function indexOfVariantInSourceList(variants, matchedVariant) {
        if (!matchedVariant || !variants || !variants.length) {
            return -1;
        }
        var matchedVid =
            matchedVariant.variantId != null
                ? String(matchedVariant.variantId).toLowerCase()
                : "";
        var i;
        var v;

        for (i = 0; i < variants.length; i++) {
            if (variants[i] === matchedVariant) {
                return i;
            }
            v = variants[i] || {};
            if (matchedVid && getVariantIdKey(v) === matchedVid) {
                return i;
            }
        }
        return -1;
    }

    function buildWindowProductFromElasticSource(source, purchasedSku) {
        if (!source) {
            return null;
        }
        var variants = source.variants || [];
        var dimensions = [];
        var ids = [];
        var prices = [];
        var matchedVariant = findVariantByPurchasedSku(
            variants,
            purchasedSku
        );
        var matchedIndex = indexOfVariantInSourceList(
            variants,
            matchedVariant
        );

        for (var i = 0; i < variants.length; i++) {
            var v = variants[i] || {};
            var wIn = coalesceVariantInches(
                v.width_in || v.widthIn,
                v.width
            );
            var hIn = coalesceVariantInches(
                v.height_in || v.heightIn,
                v.height
            );
            dimensions.push(wIn + "," + hIn);
            ids.push(
                v.variantId !== undefined && v.variantId !== null
                    ? String(v.variantId)
                    : v.itemId || ""
            );
            var price = parseFloat(v.salePrice, 10);
            if (isNaN(price) || price <= 0) {
                price = parseFloat(v.listPrice, 10);
            }
            if (isNaN(price)) {
                price = 0;
            }
            prices.push(price);
        }

        var ftaSource =
            (matchedVariant &&
                (matchedVariant.fileTypesAvailable || matchedVariant.fTA)) ||
            (variants[0] &&
                (variants[0].fileTypesAvailable || variants[0].fTA));

        return {
            id: source.itemId,
            currentVariant:
                matchedVariant &&
                (matchedVariant.variantId != null
                    ? String(matchedVariant.variantId)
                    : matchedVariant.itemId || ""),
            letteringSizeIndex: matchedIndex >= 0 ? matchedIndex : 0,
            brand: source.brand,
            definitionName: source.definitionName,
            fileTypes: normalizeFileTypesToCsv(ftaSource),
            name: source.name,
            variantDimensions: dimensions.join("|"),
            variantIds: ids.join("|"),
            variantPrices: prices.join("|"),
            catalogId: source.catalog,
        };
    }

    return {
        variantFileTypesMatchLetteringCondition:
            variantFileTypesMatchLetteringCondition,
        variantFileTypesMatchResizeCondition:
            variantFileTypesMatchResizeCondition,
        sourceHasResizeEligibleVariant: sourceHasResizeEligibleVariant,
        stockDesignSourceHasLetteringEligibleVariant:
            stockDesignSourceHasLetteringEligibleVariant,
        getLineItemProductId: getLineItemProductId,
        lineItemHasLetteringEligibleFileTypes:
            lineItemHasLetteringEligibleFileTypes,
        buildWindowProductFromElasticSource:
            buildWindowProductFromElasticSource,
    };
});
